
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { SearchForm } from '@xt/client/entities/product-v2/types'
import {
  searchContentType,
  searchProductType,
  searchStudyProgress,
  searchStudyWay,
  searchLearnTimeYear,
  searchOrderType
} from '@xt/client/dataSource/product/index'
import ComCard from '../components/card.vue'
import { Observer } from 'mobx-vue'
import { hash } from 'ohash'
import { EnumLoadProductListResult } from '@xt/client/entities/product-v2/controller'
import lodash from 'lodash'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'

@Observer
@Component({
  components: {
    InfiniteLoading,
    ComCard,
    EmptyStatus
  },
  async asyncData(ctx) {
    // 格式化合并路由参数
    const filterForm = ctx.store.$productV2.formatSearchForm(ctx.query)

    return {
      filterForm
    }
  }
})
export default class ProductPage extends Vue {
  // 筛选条件参数
  filterForm: SearchForm
  animationClass: string = ''

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get SearchOrderType() {
    return searchOrderType
  }

  get SearchLearnTimeYear() {
    return searchLearnTimeYear
  }

  get SearchStudyWay() {
    return searchStudyWay
  }

  get SearchStudyProgress() {
    return searchStudyProgress
  }

  get SearchProductType() {
    return searchProductType
  }

  get SearchContentType() {
    return searchContentType
  }

  get Store() {
    return this.$store.$productV2
  }

  get identifier() {
    const result = hash(this.filterForm)
    return result
  }

  // 触发lazy加载视区展示
  async onTransitionEnd() {
    if (this.animationClass !== '') {
      this.animationClass = ''
    }
    setTimeout(() => {
      this.animationClass = 'lazy-trigger'
    }, 100)
  }

  changeForm(key: string, value: unknown) {
    if (!(key in this.filterForm)) {
      console.warn(`属性 ${key} 不存在于对象中`)
      return
    }

    if (lodash.isEqual(this.filterForm[key], value)) {
      return
    }

    this.Store.resetStatus()

    this.filterForm[key] = value

    this.$router.replace({ query: this.Store.toSearchQuery(this.filterForm) })
  }

  courseProgressChange(value) {
    this.changeForm('studyProgress', value)
  }
  studyWayChange(value) {
    this.changeForm('studyWay', value)
  }
  startTimeChange(value) {
    this.changeForm('learnTimeYear', value)
  }

  getCpContainer() {
    const el: HTMLElement = document.querySelector(`#xt-product-course-progress-select`) ?? document.body

    return el
  }
  getSwContainer() {
    const el: HTMLElement = document.querySelector(`#xt-product-study-way-select`) ?? document.body

    return el
  }
  getStContainer() {
    const el: HTMLElement = document.querySelector(`#xt-product-start-time-select`) ?? document.body

    return el
  }

  async infiniteHandler($state: StateChanger) {
    const result = await this.Store.loadProductList(this.filterForm)

    switch (result) {
      case EnumLoadProductListResult.Cancel:
        console.warn('命中节流逻辑')
        break
      case EnumLoadProductListResult.Error:
        $state.error()
        break
      case EnumLoadProductListResult.Loaded:
        $state.loaded()
        break
      case EnumLoadProductListResult.Complete:
        if (this.Store.rawList.length > 0) {
          $state.loaded()
        }
        $state.complete()
        break
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.Store.clean()
  }
}
